import axios from "axios";
import { AuthenticationURL } from "../../Services";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function getUserInfo() {
  ShowAwaiting();
  var res = await axios.get(AuthenticationURL + "api/info", {
    withCredentials: true,
  });
  HideAwaiting();
  return res.data;
}
